import type { ComparisonConfig } from './ComparisonPage';


const INNROAD_ZH: ComparisonConfig = {
  slug: 'hotelstack-vs-innroad',
  competitorName: 'innRoad',
  heroTitle: 'HotelStack.io 对比 innRoad',
  heroSubtitle: 'innRoad是一款面向独立酒店的美国云端PMS，功能集较为基础。HotelStack.io提供36个模块，包括高级收益管理、餐饮/POS、多物业支持和全球合规——价格相当。',
  overviewComparison: [
    { label: '模块总数', hotelstack: '36个集成模块', competitor: '8+核心功能' },
    { label: '定价', hotelstack: '起价$49/月', competitor: '起价$100+/月' },
    { label: '多物业', hotelstack: '完整连锁管理', competitor: '不支持' },
    { label: '餐饮/POS', hotelstack: '内置', competitor: '不可用' },
    { label: '全球覆盖', hotelstack: '40多个国家', competitor: '聚焦美国' },
    { label: '收益管理', hotelstack: '高级（内置）', competitor: '基础房价工具' },
  ],
  featureTable: [
    {
      category: '核心PMS',
      features: [
        { name: '云端PMS', hotelstack: true, competitor: true },
        { name: '可视化房态板', hotelstack: true, competitor: true },
        { name: '预订管理', hotelstack: true, competitor: true },
        { name: '夜审向导', hotelstack: true, competitor: true },
        { name: '宾客账单管理', hotelstack: true, competitor: true },
        { name: '在线入住门户', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '分销与预订',
      features: [
        { name: '渠道管理（100+ OTA）', hotelstack: true, competitor: 'OTA数量有限' },
        { name: 'GDS连接', hotelstack: true, competitor: true },
        { name: '免佣金预订引擎', hotelstack: true, competitor: true },
        { name: '团队预订', hotelstack: true, competitor: '基础' },
        { name: '协议客户房价管理', hotelstack: true, competitor: '有限' },
      ],
    },
    {
      category: '收益管理',
      features: [
        { name: '动态定价规则', hotelstack: true, competitor: '基础' },
        { name: '假设场景收益模拟器', hotelstack: true, competitor: false },
        { name: '竞争对手价格监控', hotelstack: true, competitor: false },
        { name: '需求预测', hotelstack: true, competitor: false },
        { name: 'RevPAR分析', hotelstack: true, competitor: '基础' },
      ],
    },
    {
      category: '运营与餐饮',
      features: [
        { name: 'POS终端', hotelstack: true, competitor: false },
        { name: '客房送餐模块', hotelstack: true, competitor: false },
        { name: '客房清洁管理', hotelstack: true, competitor: '基础' },
        { name: '维修工单', hotelstack: true, competitor: false },
        { name: '员工排班', hotelstack: true, competitor: false },
        { name: '厨房显示系统', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '报表与合规',
      features: [
        { name: '快报', hotelstack: true, competitor: true },
        { name: '损益表', hotelstack: true, competitor: false },
        { name: '预订进度报告', hotelstack: true, competitor: false },
        { name: '多币种账单', hotelstack: true, competitor: false },
        { name: '区域税务合规', hotelstack: true, competitor: '仅美国' },
        { name: '自定义报表生成器', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '弹性与离线',
      features: [
        { name: '支持离线的PWA', hotelstack: true, competitor: false },
        { name: '离线操作队列', hotelstack: true, competitor: false },
        { name: '重新连接时后台同步', hotelstack: true, competitor: false },
        { name: '冲突感知对账', hotelstack: true, competitor: false },
        { name: '可安装的前台系统', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '企业与团队销售',
      features: [
        { name: '企业协议价管理', hotelstack: true, competitor: '有限' },
        { name: '团队预订与房间名单', hotelstack: true, competitor: '基础' },
        { name: '应收账龄与业绩报表', hotelstack: true, competitor: false },
        { name: '餐厅预订', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '员工与人力资源',
      features: [
        { name: '员工名录与排班', hotelstack: true, competitor: false },
        { name: '薪资处理', hotelstack: true, competitor: false },
        { name: '休假与考勤', hotelstack: true, competitor: false },
        { name: '绩效分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: '包含全部36个模块。全球多币种支持。支持EUR、GBP、AED、INR、THB区域定价。免费入驻和迁移。',
    competitorNote: '报价制定价，起价$100+/月。聚焦美国，国际功能有限。基础功能集，无餐饮、无多物业、无高级分析。',
  },
  advantages: [
    '四倍的模块数量（36对8+），起步价约为一半',
    '完整的多物业连锁管理——innRoad仅支持单一物业',
    '完整的餐饮模块，含POS、客房送餐、厨房显示和菜单管理',
    '高级收益管理，含动态定价、需求预测和模拟器',
    '覆盖40多个国家，对比innRoad仅聚焦美国',
    '多币种账单和区域税务合规，面向国际物业',
    '忠诚度计划、宾客CRM和自动化沟通功能',
    '免费入驻和数据迁移，全天候专属支持',
  ],
  verdict: {
    title: '我们的评价',
    summary: 'innRoad是面向美国独立酒店的简单云端PMS，满足基础预订和前台管理需求。HotelStack.io提供更全面的平台，拥有四倍的模块、多物业支持、餐饮/POS、高级收益工具和全球覆盖——价格更低。对于任何计划超越基础PMS需求的酒店，HotelStack.io是明智之选。',
    bestFor: [
      '希望从基础PMS升级到完整平台的独立酒店',
      '需要innRoad缺乏的餐饮、POS和运营工具的物业',
      '拓展国际市场需要多币种和合规工具的酒店',
      '希望为未来增长提供多物业管理的物业',
      '寻求超越基础房价设置的高级收益管理的酒店',
    ],
  },
  faqItems: [
    { question: '能否从innRoad迁移到HotelStack.io？', answer: '可以。我们的迁移团队负责从innRoad完整迁移数据，包括宾客档案、预订历史、房价方案和房间配置。迁移免费，通常在48小时内完成，零停机时间。' },
    { question: 'HotelStack.io是否像innRoad一样支持美国独立酒店？', answer: '当然支持。HotelStack.io支持美国及40多个其他国家的独立酒店。美国酒店获得全部36个模块，包括innRoad缺乏的餐饮/POS、收益管理和多物业支持——起价$49/月。' },
    { question: 'HotelStack.io与innRoad在GDS连接方面如何比较？', answer: '两个平台都通过Amadeus和Sabre提供GDS连接。HotelStack.io还连接全球100多个OTA、提供元搜索集成，并包含免佣金预订引擎（BookMyRoom.io）——全部包含在基础价格中。' },
    { question: 'HotelStack.io能否像innRoad不能的那样处理多物业？', answer: '可以。HotelStack.io包含完整的连锁管理，含集中仪表盘、跨物业分析、共享房价分销、品牌标准执行和合并报表。innRoad仅为单一物业运营设计。' },
  ],
};

const WEBREZPRO_ZH: ComparisonConfig = {
  slug: 'hotelstack-vs-webrezpro',
  competitorName: 'WebRezPro',
  heroTitle: 'HotelStack.io 对比 WebRezPro',
  heroSubtitle: 'WebRezPro是一款以财务为重点的加拿大云端PMS，面向中小型酒店。HotelStack.io提供现代、功能丰富的平台，拥有36个模块、企业级UI、高级收益工具和完整餐饮/POS——为下一代酒店业而打造。',
  overviewComparison: [
    { label: '模块总数', hotelstack: '36个集成模块', competitor: '10+核心功能' },
    { label: '定价', hotelstack: '起价$49/月', competitor: '起价$75+/月' },
    { label: 'UI/UX品质', hotelstack: '现代暗色奢华风格', competitor: '功能性/较旧' },
    { label: '餐饮/POS', hotelstack: '内置', competitor: '不可用' },
    { label: '收益管理', hotelstack: '高级（内置）', competitor: '基础房价工具' },
    { label: '多物业', hotelstack: '完整连锁管理', competitor: '有限' },
  ],
  featureTable: [
    {
      category: '核心PMS',
      features: [
        { name: '云端PMS', hotelstack: true, competitor: true },
        { name: '可视化房态板', hotelstack: true, competitor: true },
        { name: '预订管理', hotelstack: true, competitor: true },
        { name: '夜审向导', hotelstack: true, competitor: true },
        { name: '宾客账单管理', hotelstack: true, competitor: true },
        { name: '在线入住门户', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '财务与会计',
      features: [
        { name: '集成会计', hotelstack: true, competitor: true },
        { name: '损益表', hotelstack: true, competitor: true },
        { name: '应收账款', hotelstack: true, competitor: true },
        { name: '多币种账单', hotelstack: true, competitor: '有限' },
        { name: '区域税务合规', hotelstack: true, competitor: '以CAD/USD为主' },
        { name: '自定义发票模板', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '收益与分销',
      features: [
        { name: '渠道管理（100+ OTA）', hotelstack: true, competitor: 'OTA数量较少' },
        { name: '动态定价规则', hotelstack: true, competitor: '基础' },
        { name: '假设场景收益模拟器', hotelstack: true, competitor: false },
        { name: '竞争对手价格监控', hotelstack: true, competitor: false },
        { name: '需求预测', hotelstack: true, competitor: false },
        { name: '免佣金预订引擎', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '餐饮与运营',
      features: [
        { name: 'POS终端', hotelstack: true, competitor: false },
        { name: '客房送餐模块', hotelstack: true, competitor: false },
        { name: '厨房显示系统', hotelstack: true, competitor: false },
        { name: '客房清洁管理', hotelstack: true, competitor: true },
        { name: '维修工单', hotelstack: true, competitor: false },
        { name: '员工排班', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '宾客与企业级',
      features: [
        { name: '360度宾客档案', hotelstack: true, competitor: '基础' },
        { name: '忠诚度计划管理', hotelstack: true, competitor: false },
        { name: '宾客沟通自动化', hotelstack: true, competitor: '有限' },
        { name: '连锁酒店仪表盘', hotelstack: true, competitor: '有限' },
        { name: '跨物业分析', hotelstack: true, competitor: false },
        { name: '品牌标准执行', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '弹性与离线',
      features: [
        { name: '支持离线的PWA', hotelstack: true, competitor: false },
        { name: '离线操作队列', hotelstack: true, competitor: false },
        { name: '重新连接时后台同步', hotelstack: true, competitor: false },
        { name: '冲突感知对账', hotelstack: true, competitor: false },
        { name: '可安装的前台系统', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '企业与团队销售',
      features: [
        { name: '企业协议价管理', hotelstack: true, competitor: false },
        { name: '团队预订与房间名单', hotelstack: true, competitor: false },
        { name: '应收账龄与业绩报表', hotelstack: true, competitor: false },
        { name: '餐厅预订', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '员工与人力资源',
      features: [
        { name: '员工名录与排班', hotelstack: true, competitor: false },
        { name: '薪资处理', hotelstack: true, competitor: false },
        { name: '休假与考勤', hotelstack: true, competitor: false },
        { name: '绩效分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$75+',
    hotelstackNote: '包含全部36个模块。现代企业级UI。支持EUR、GBP、AED、INR、THB区域定价。免费入驻和迁移。',
    competitorNote: '按房间计价，起价$75+/月CAD。功能性但较旧的界面。餐饮有限、多物业有限，主要支持北美。',
  },
  advantages: [
    '模块数量超过三倍（36对10+），搭配现代企业级界面',
    '完整的餐饮模块，含POS、客房送餐和厨房管理',
    '高级收益管理，含动态定价、需求预测和假设场景模拟器',
    '2026年设计的现代暗色奢华UI，对比WebRezPro功能性但较旧的界面',
    '完整的多物业连锁管理，含集中分析和房价分销',
    '覆盖40多个国家，对比WebRezPro聚焦北美',
    '忠诚度计划、宾客CRM和自动化沟通，促进复购',
    '免费入驻和数据迁移，全天候专属支持',
  ],
  verdict: {
    title: '我们的评价',
    summary: 'WebRezPro是面向北美中小型酒店的可靠加拿大PMS，拥有强大的会计功能。然而，其较旧的UI、有限的功能集以及缺乏餐饮、高级收益工具和企业可扩展性使其在2026年竞争力不足。HotelStack.io提供现代、全面的平台，在会计方面与WebRezPro匹配，同时增加22+额外模块、世界级界面和全球能力。',
    bestFor: [
      '希望在不牺牲会计深度的前提下获得现代UI升级的酒店',
      '需要超越基础PMS的餐饮、POS和厨房管理的物业',
      '寻求高级收益管理和动态定价工具的酒店',
      '拓展北美以外国际市场的物业',
      '需要完整多物业连锁管理的成长中酒店集团',
    ],
  },
  faqItems: [
    { question: '能否从WebRezPro迁移到HotelStack.io？', answer: '可以。我们的迁移团队负责从WebRezPro完整迁移数据，包括宾客档案、预订历史、房价方案、会计数据和房间配置。迁移免费，通常在48小时内完成，零停机时间。' },
    { question: 'HotelStack.io的会计功能能否匹配WebRezPro？', answer: '可以。HotelStack.io包含集成会计、损益表、应收账款、自定义发票和多币种账单。此外，还增加了22+额外模块，包括WebRezPro缺乏的餐饮、收益管理、宾客CRM和多物业管理。' },
    { question: 'HotelStack.io的UI与WebRezPro相比如何？', answer: 'HotelStack.io采用最新Web技术打造的现代暗色奢华界面，在所有设备上提供响应式设计。WebRezPro的界面功能性尚可但较为陈旧，是为早期Web应用时代设计的。' },
    { question: 'HotelStack.io适合目前使用WebRezPro的加拿大物业吗？', answer: '当然适合。HotelStack.io支持包括CAD在内的多币种账单、加拿大税务合规（GST/HST/PST）以及所有主要北美OTA连接。许多加拿大物业因额外模块和现代体验而转向我们。' },
  ],
};


export const COMPARISON_ZH_P3B: Record<string, ComparisonConfig> = {
  'hotelstack-vs-innroad': INNROAD_ZH,
  'hotelstack-vs-webrezpro': WEBREZPRO_ZH,
};
